export async function api({ baseUrl, endpoint, method, headers = {}, body }) {
  try {
    const prom = await fetch(`${baseUrl}${endpoint}`, {
      method,
      headers,
      body
    });

    if (prom.ok) {
      const data = await prom.json();
      data.status = prom.status;
      return data;
    }

    return prom;
  } catch (err) {
    return err;
  }
}
